module.exports = __webpack_public_path__ + "static/media/rank-mini-2-icon.16da96c0.png";